import { DeleteIcon } from './icons/Delete';
import { Button } from './Button';

export function TodoItem({
    id,
    title,
    completed,
    deadline,
    onDelete,
    onComplete,
    onReopen,
}) {
    const handleClick = (e) => {
        e.stopPropagation();

        if (completed) {
            return onReopen(id);
        }

        onComplete(id);
    }
    const handleDeleteClick = () => {
        onDelete(id);
    };

    const className = [
        'block cursor-pointer hover:bg-gray-50',
    ];
    if (completed) {
        className.push('line-through');
    }

    return (
        <li className={className.join(' ')} onClick={handleClick}>
            <div className="flex items-center px-4 py-4 sm:px-6">
                <div className="flex-1 min-w-0 sm:flex sm:items-center sm:justify-between">{title} ({deadline})</div>
                <div className="flex flex-shrink-0 ml-5 space-x-4">
                    <Button onClick={handleDeleteClick}>
                        <DeleteIcon />
                    </Button>
                </div>
            </div>
        </li>
    );
};
